import { request } from '../../utils/request';

/**
 * @returns this should return the user information
 */
export const getUserProfile = (authToken: string) => {
  return request({
    method: 'GET',
    url: '/auth/get-me',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
